/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Thriller_NavInputs */

const en_thriller_nav = /** @type {(inputs: Thriller_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thriller Dance`)
};

/**
* | output |
* | --- |
* | "Thriller Dance" |
*
* @param {Thriller_NavInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const thriller_nav = /** @type {((inputs?: Thriller_NavInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Thriller_NavInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_thriller_nav(inputs)
});
export { thriller_nav as "thriller.nav" }